import angular from 'angular'
// import installApp from './installApp';

import switcher from './switcher'
import selectTree from './selectTree'
import selectTree2 from './selectTree2'
import selectTree3 from './selectTree3'
import chosen from './chosen'
import select2 from './select2'
import formvalidate from './formvalidate'
import sweetalert from './sweetalert'
import subNav from './subNav'
import importexcel from './importexcel'
import hasPermit from './hasPermit'
import breadcrumb from './breadcrumb'
import autoHeight from './autoHeight'
import jqueryScrollbar from './jqueryScrollbar'
import checkbox from './checkbox'
import checkbox2 from './checkbox2'
import globalFn from './globalFn'
import queryForm from './queryForm'
import dragModal from './dragModal'
import customizableView from './customizableView'
import orgSelect from './orgSelect'
import tableRelated from './tableRelated'
import billChange from './billChange'
import invoiceRelated from './invoiceRelated'
import smarty from './smarty'
import iFrameTemp from './iFrameTemp'
import templateTree from './templateTree'
import errorPage from './errorPage'
import noresPage from './noResPage'
import btnModal from './btnModal'
import checkboxComponent from './checkboxComponent'
import etPagination from './etPagination'
import setFocus from './setFocus'
import treeSelect from './treeSelect'
import btnDropdown from './btnDropdown'
import popupSelect from './popupSelect'
import popupSelect2 from './popupSelect2'
import approvalProcess from './approvalProcess'
import permissionOrgTree from './permissionOrgTree'
import deductionCheck from './deductionCheck'
import statisticsDeductionCheck from './statisticsDeductionCheck'
import select from './select'
import drawBack from './drawBack'
import statisticsDrawBack from './statisticsDrawBack'
import dataCollection from './dataCollection'
import orgTreeSearch from './orgTreeSearch'
import zTree from './zTree'
import etPageDeclare from './etPageDeclare'
import queryTree from './queryTree'
import yTree from './yTree'

export default angular.module('app.components', [
  switcher,
  selectTree,
  chosen,
  select2,
  selectTree3,
  formvalidate,
  sweetalert,
  subNav,
  importexcel,
  hasPermit,
  breadcrumb,
  autoHeight,
  selectTree2,
  jqueryScrollbar,
  checkbox,
  checkbox2,
  globalFn,
  queryForm,
  dragModal,
  customizableView,
  orgSelect,
  tableRelated,
  billChange,
  invoiceRelated,
  smarty,
  iFrameTemp,
  templateTree,
  errorPage,
  noresPage,
  btnModal,
  checkboxComponent,
  etPagination,
  setFocus,
  treeSelect,
  btnDropdown,
  popupSelect,
  popupSelect2,
  approvalProcess,
  permissionOrgTree,
  deductionCheck,
  statisticsDeductionCheck,
  select,
  drawBack,
  statisticsDrawBack,
  dataCollection,
  orgTreeSearch,
  zTree,
  etPageDeclare,
  queryTree,
  yTree,
]).name



// WEBPACK FOOTER //
// ./src/components/index.js